import React from 'react'
import OurServicesInfo from '../templates/Services/ourServicesInfo'

export default function Services() {
  return (
    <div>
      <OurServicesInfo />
    </div>
  )
}
